module.exports = __webpack_public_path__ + "d80d3a388742fb0dd7350dc73260145c.svg";